import type { ReactNode } from "react";

interface AccountabilitySectionProps {
  title: string;
  children: ReactNode;
}

/** Shared shell for each independently-scrolling panel on the Accountability page. */
export function AccountabilitySection({ title, children }: AccountabilitySectionProps) {
  return (
    <section className="flex min-h-0 flex-col rounded-xl border border-border bg-card/40 lg:overflow-hidden">
      <header className="border-b border-border bg-muted/30 px-4 py-3">
        <h2 className="text-sm font-semibold uppercase tracking-wide text-muted-foreground">{title}</h2>
      </header>
      <div className="min-h-0 flex-1 overflow-y-auto p-3">{children}</div>
    </section>
  );
}
